import { render, staticRenderFns } from "./SettingFamilyDetail.vue?vue&type=template&id=855dc446&"
import script from "./SettingFamilyDetail.vue?vue&type=script&lang=js&"
export * from "./SettingFamilyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports